// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","header":"_22Aqkscqt4MC","heading":"_356sqGGen8Jr"};